export const miAnalysisSkillContract = {
  id: 'mi_analysis',
  version: '1.0.0',
  name: 'Mi Analise',
  domain: 'fps_mobile',
  supportedGames: ['pubg_mobile', 'free_fire', 'codm', 'other'],
  gameAliases: {
    codm: ['cod', 'cod mobile', 'call of duty mobile', 'call of duty: mobile']
  },
  description: 'Analisa gameplay em video e transforma a partida em insights, erros provaveis e proximas acoes.',
  intentExamples: [
    'analisa minha gameplay',
    'olha esse video e me fala onde errei',
    've meu x1',
    'analisa minha mira nesse replay',
    'quero que a Mi analise minha movimentacao'
  ],
  requiredSlots: ['analysisGoal', 'video'],
  optionalSlots: ['game', 'notes', 'context', 'language'],
  slotSchemas: {
    game: {
      type: 'enum',
      values: ['pubg_mobile', 'free_fire', 'codm', 'other'],
      aliases: {
        codm: ['cod', 'cod mobile', 'call of duty mobile', 'call of duty: mobile']
      }
    },
    analysisGoal: {
      type: 'enum',
      values: ['gameplay', 'replay', 'x1', 'aim', 'movement']
    },
    video: {
      type: 'file',
      acceptedKinds: ['video'],
      required: true
    },
    notes: {
      type: 'string',
      maxLength: 1000
    },
    context: {
      type: 'object',
      description: 'Contexto recente seguro, como diagnostico Sensi-IA, treino Coach ou comentario do usuario.'
    },
    language: {
      type: 'string'
    }
  },
  askForMissingSlots: {
    game: 'Qual jogo e esse: PUBG Mobile, Free Fire ou CODM?',
    analysisGoal: 'O que voce quer que eu analise nesse video: mira, movimentacao, X1 ou gameplay geral?',
    video: 'Me envia o video da jogada para eu analisar de verdade.'
  },
  execution: {
    handler: 'MiAnalysisSkillAdapter',
    requiresBackend: true,
    costClass: 'high',
    requiresCredits: false,
    requiresPlan: 'pro'
  },
  output: {
    mode: 'conversation',
    schema: 'gameplay_analysis_result'
  },
  guardrails: {
    noVisualValidationWithoutVideo: true,
    askForVideoInConversation: true,
    useOfficialResilientUpload: true,
    doNotReactivateLegacyCoachUploadRoutes: true,
    backendAndWorkerAreAuthoritative: true,
    humanizeUploadAndWorkerErrors: true,
    doNotExposeRawWorkerPayload: true
  },
  capabilityMapping: {
    primaryCapabilityId: 'mi_analysis_gameplay',
    relatedCapabilityIds: [
      'mi_analysis_replay',
      'mi_analysis_x1',
      'mi_analysis_aim',
      'mi_analysis_movement'
    ]
  }
};

export default miAnalysisSkillContract;
